import React, { Suspense, Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import * as Sentry from "@sentry/react";
import moment from "moment";
import Avtar from "./MsgBubbleComponent/Avtar";

const chuckExperssion = new RegExp(/^Loading CSS chunk$/);
const notFoundExpression = new RegExp(/^Object Not Found Matching$/);
Sentry.init({
  dsn: "https://50b49df978b4b68df6336164f5df5bfc@o880208.ingest.sentry.io/4506575621849088",
  ignoreErrors: [
    "TypeError: Failed to fetch",
    "TypeError: NetworkError when attempting to fetch resource.",
    "TypeError: cancelled",
    "TypeError: Load failed",
    "/Object Not Found Matching\b/",
    "AxiosError: Network Error",
    "AxiosError: Request aborted",
    "/Loading CSS chunk\b/",
    "Non-Error promise rejection captured",
    chuckExperssion,
    notFoundExpression,
  ],
  beforeSend(event, hint) {
    // const error = hint.originalException;
    // if (
    //   error &&
    //   error.message &&
    //   (error.message.match(chuckExperssion) ||
    //     error.message.match(notFoundExpression) ||
    //     error.message.match(/Object Not Found Matching/i) ||
    //     error.message.match(/Loading CSS chunk/i))
    // ) {
    //   return null;
    // }
    // return event;
    if (
      event !== undefined &&
      event.exception !== undefined &&
      event.exception.values !== undefined &&
      event.exception.values.length == 1
    ) {
      var e = event.exception.values[0];
      if (
        (e.type === "UnhandledRejection" &&
          e.value === "Non-Error promise rejection captured with value: ") ||
        (event.exception.values.filter(f => f.type.match(chuckExperssion) || f.value.match(chuckExperssion)).length > 0)
        || (event.exception.values.filter(f => f.type.match(notFoundExpression) || f.value.match(notFoundExpression)).length > 0)
      ) {
        return null;
      }
    }
  },
  integrations: [
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const MsgApp = React.lazy(() => import("./MsgApp"));

function decodeURL() {
  if (!window.location.href.split("?")[1]) {
    console.log("No data passed in to Chat element :(.");
    return;
  }
  var params = window.location.href.split("?")[1].split("&");
  var data = {};
  for (var x in params) {
    data[params[x].split("=")[0]] = decodeURIComponent(params[x].split("=")[1]);
  }
  return data;
}
var parent_location,
  parent_title,
  gid,
  iid,
  pid,
  mobile,
  parent_referrer,
  defaultOpen,
  position,
  customStyle,
  previewMode,
  token,
  botData,
  buttonscript,
  inputprechat;

var data = decodeURL();

if (data) {
  parent_referrer = data.referrer;
  parent_location = data.location;
  parent_title = data.title;
  gid = data.gid;
  pid = data.pid;
  token = data.token;
  iid = data.iid;
  mobile = data.mobile;
  defaultOpen =
    data.open === undefined ? false : data.open === "0" ? false : true;
  previewMode = data.preview ? data.preview : false;
  position = data.position === "left" ? "chat_area_left" : "chat_area";
  customStyle = data.custom ? "custom" : "";
  buttonscript = data.buttonscript === undefined ? false : true;
  inputprechat = data.inputPreChat === undefined ? "" : data.inputPreChat;
}

if (!gid || !iid) {
  gid = "73574010-2f33-4b41-8b8a-09d18b025a56";
  mobile = true;
  iid = "1ae35252-799c-41a0-b2a6-c086ccf68f25";
  defaultOpen = false;
  position = "chat_area";
  customStyle = "";
}
// Make sure frame is open when the bot is being interacted with (see chatplugin.js)
window.addEventListener("click", () => {
  window.postMessage("messengerwindowOpen");
});

class App extends Component {
  constructor(props) {
    super(props);
    {
    }
    this.state = {
      animation: {
        bubbleToFadeIn: true,
      },
      isLoading: true,
      opened:
        this.props.defaultOpen ||
        (mobile === "false" &&
          localStorage.getItem(iid + "-opened") === "open"),
      prechatData: null,
    };
    window.addEventListener("message", this.windowMessage.bind(this), false);
  }
  componentDidMount() {
    if (
      inputprechat !== undefined &&
      inputprechat !== null &&
      inputprechat !== ""
    ) {
      var params = inputprechat.trim().split(";");
      var data = {};
      for (var x in params) {
        if (params[x] !== "") {
          var text = params[x].split(":")[0].trim();
          var value = params[x].split(":")[1].trim();
          data[text] = value;
        }
      }
      this.setState({
        prechatData: data,
      });
    }
    var contentUrl = 'https://assets.bookmebob.com';
    if (window.location.host.match('concierge.synxis.com'))
      contentUrl = 'https://assets.concierge.synxis.com';

    if(window.location.host.includes("devtest") || window.location.host.includes("localhost")){
      contentUrl = 'https://botintegrationdemo.blob.core.windows.net';
    }
    fetch(`
      ${contentUrl}/messengerx/${iid}.json?ut=${Date.now()}`
    )
      .then((res) => res.json())
      .then((result) => {
        if (!gid || !iid) {
          gid = result.gid;
          iid = result.iid;
        }
        console.log(moment().format("YYYY-MM-DD hh:mm:ss"), "Json Loaded");
        if (result.disabled === false && result.nudges !== undefined && result.botSettings !== undefined)
          this.setState({ botData: result });

        this.setState({ isLoading: false });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
  }

  windowMessage(event) {
    if (
      event !== undefined &&
      event.data !== undefined &&
      event.data === "openAvtar"
    ) {
      this.setState({ opened: false });
    }
  }

  openMessenger() {
    this.setState({ opened: true });
    window.postMessage("openChatWindow");
  }

  hintClosed() {
    this.setState({ currentNudge: undefined });
  }

  render() {
    return (
      <Fragment>
        {gid !== undefined && iid !== undefined && !this.state.isLoading && (
          <Fragment>
            <MsgApp
              parent_location={parent_location}
              parent_title={parent_title}
              parent_referrer={parent_referrer}
              gid={gid}
              iid={iid}
              pid={pid}
              token={token}
              mobile={mobile}
              botData={this.state.botData}
              defaultOpen={defaultOpen}
              buttonscript={buttonscript}
              position={position}
              customStyle={customStyle}
              previewMode={previewMode}
              prechatData={this.state.prechatData}
            ></MsgApp>
            {/* {(!this.state.opened && this.state.botData !== undefined) && (
              <Suspense fallback={<div></div>}>
                <Avtar
                  botSettings={this.state.botData?.botSettings}
                  fadeIn={this.state.animation.bubbleToFadeIn}
                  currentNudge={this.state.botData?.nudges}
                  mobile={mobile}
                  disabledChatbot={this.state.botData.disabled}
                  onOpened={this.openMessenger.bind(this)}
                  position={position}
                >
                </Avtar>
              </Suspense>
            )} */}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

ReactDOM.render(
  <Provider store={store}>
    <Suspense
      fallback={
        <div id="spinner" className="container">
          <div className="loading"></div>
        </div>
      }
    >
      <App></App>
    </Suspense>
  </Provider>,
  document.getElementById("root")
);
